module.exports = __webpack_public_path__ + "static/portfolio_gallery_12-28283faca9f49d7a634087ee880c532b.jpg";